// extracted by mini-css-extract-plugin
export var content = "notification-module--content--8c279";
export var text = "notification-module--text--52fa8";
export var wrapper = "notification-module--wrapper--dcd11";